<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [errors]="question.errors"
  [key]="question.key"
  [value]="value"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>

<!-- For iOS and Android -->
<ng-container *ngIf="!isWebview">
  <ion-item [formGroup]="formGroup" lines="none" (click)="addFile()">
    <ion-input
      placeholder="{{ 'FILE.CHOOSE_DOC' | translate }}"
      readonly="true"
      [value]="question && question.fileName"
    ></ion-input>
    <input type="hidden" [formControlName]="question.key" />
    <ion-button fill="clear" color="dark" expand="block" slot="end">
      <ion-icon slot="icon-only" name="add-circle"></ion-icon>
    </ion-button>
  </ion-item>
</ng-container>

<!-- For webview -->
<ng-container *ngIf="isWebview">
  <ion-item [formGroup]="formGroup" lines="none">
    <input
      type="file"
      placeholder="{{ 'FILE.CHOOSE_DOC' | translate }}"
      [attr.add-file]="
        (question && question.fileName) || 'FILE.CHOOSE_DOC' | translate
      "
      readonly="true"
      class="file-input"
      id="edocsFileInput"
      accept="image/jpeg,image/jpg,image/png,application/pdf"
      (change)="fileSelected($event)"
    />
    <input type="hidden" [formControlName]="question.key" />
    <ion-button fill="clear" color="dark" expand="block" slot="end">
      <ion-icon slot="icon-only" name="add-circle"></ion-icon>
    </ion-button>
  </ion-item>
</ng-container>
